import { FunnelModuleResolver } from '@modules/funnels/shared/services/funnel-module.resolver';
import { PermissionsResolver } from '@shared/services/permissions.resolver';

export const SHARED_RESOLVERS = [FunnelModuleResolver, PermissionsResolver];
